import { createRoute } from '@tanstack/react-router';
import { OjetaList } from '@/modules/ojeta-vozidla/OjetaList';
import { parseOjetaSearch } from '@/modules/ojeta-vozidla/helpers';
import { Route as RootRoute } from './__root';

export const Route = createRoute({
  getParentRoute: () => RootRoute,
  path: '/ojeta-vozidla',
  component: OjetaList,
  validateSearch: parseOjetaSearch,
});
